import { Icon, IconProps } from './Icon';

export const SafetyTipsIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M14.078 9.24795C15.226 10.3959 15.226 12.2559 14.078 13.4039C12.93 14.5519 11.07 14.5519 9.92204 13.4039C8.77404 12.2559 8.77404 10.3959 9.92204 9.24795C11.07 8.10095 12.93 8.10095 14.078 9.24795"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 11.1805C20 15.7215 16.587 19.9685 12 20.9995C7.413 19.9685 4 15.7215 4 11.1805V7.24352C4 6.43052 4.492 5.69952 5.243 5.39252L10.243 3.34552C11.369 2.88352 12.632 2.88352 13.756 3.34552L18.756 5.39252C19.509 5.70152 19.999 6.43052 19.999 7.24352V11.1805H20Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
